import type { FormProps } from 'antd';
import { Drawer, Form, FormInstance, Input, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useRef, useState } from "react";
import * as BenefitApi from '../../../../api/rank/benefitApi';
import useToast from "../../../../hook/useToast";
import './style.scss';
import { getListCarCompany, IHobby, ISelectOption } from '../../../../api/selectOptions/selectOptionsApi';

interface DrawerProps {
  isOpen: boolean
  closeDrawer: () => void
  dataInfoBenefit?: BenefitApi.IInfoBenefit
  className?: string;
  onShowHistory?: () => void;
  getListBenefit: () => void
}
const DrawerAddBenefitPolicies: React.FC<DrawerProps> = ({
  isOpen,
  dataInfoBenefit,
  closeDrawer,
  getListBenefit
}) => {
  const [form] = useForm();
  const pushToast = useToast();
  const inputRef = useRef<FormInstance>(null);
  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };
  const [carCompany, setCarCompany] = useState<ISelectOption[]>([])
  const [selectedCarCompany, setSelectedCarCompany] = useState<number[]>([])


  const convertData = (data: IHobby[]) => {
    const convertData = data.map((item) => ({
      value: item.id,
      label: item.title,
    }))
    return convertData
  }

  const gListCarCompany = async () => {
    const result = await getListCarCompany();
    if (result?.status) {
      setCarCompany([
        { label: "Tất cả", value: -1 },
        ...convertData(result.data)
      ])
    } else {
    }
  }


  const onFinish: FormProps["onFinish"] = async (values) => {
    const result = await BenefitApi.addBenefitPolicies(values.code, values.title, values.description, values.carCompany ?? [-1]);
    if (result?.status) {
      pushToast("Thêm mới thành công!", "success", 1000)
      closeDrawer();
      getListBenefit()
    } else {
      pushToast(result.message, "error", 1000)
    }
  };

  const handleReset = () => {
    if (inputRef.current) {
      inputRef.current.resetFields();
    }
  };

  useEffect(() => {
    gListCarCompany()
  }, [])

  useEffect(() => {

    handleReset()
    setSelectedCarCompany([])
  }, [isOpen])


  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Drawer
        title={<p className="font-medium fw-500 text-344054 p-4 bg-FCFCFD">Chỉnh sửa quyền lợi  chính sách</p>}
        placement="right"
        rootClassName="custom-drawer"
        closable={false}
        onClose={closeDrawer}
        open={isOpen}
        footer={
          <div className="p-4 bg-FCFCFD d-flex justify-between align-center">
            <p className="text-sm text-98A2B3 font-regular cursor-pointer"
              onClick={handleReset}
            >Làm mới thông tin</p>
            <button onClick={submitForm} className="border-none bg-096DD9 rounded-2 px-15-px  h-8  text-sm font-regular text-white"> Thêm quyền lợi</button>
          </div>
        }
      >
        <div className=" d-flex flex-column">

          <div className="d-flex flex-column gap-18-px">
            <p className="text-base fw-500 font-medium text-344054">Tên quyền lợi</p>
            <Form.Item
              label="Mã quyền lợi"
              layout='vertical'
              style={{ marginBottom: 0 }}
              name="code"
              rules={[{ required: true, message: 'Vui lòng nhập mã quyền lợi!' }]}
            >
              <Input
                placeholder="Mã quyền lợi" />
            </Form.Item>
            <Form.Item
              layout='vertical'
              label="Tên quyền lợi"
              style={{ marginBottom: 0 }}
              name="title"
              rules={[{ required: true, message: 'Vui lòng nhập tên quyền lợi!' }]}
            >
              <Input
                placeholder="Tên quyền lợi" />
            </Form.Item>

            <Form.Item
              layout='vertical'
              label="Thương hiệu xe sở hữu"
              style={{ marginBottom: 0 }}
              name="carCompany"
              rules={[{ required: true, message: 'Vui lòng chọn thương hiệu xe!' }]}
            >
              <Select
                placeholder="Thương hiệu xe sở hữu"
                popupMatchSelectWidth={false}
                mode="multiple"
                className="custom-scroll-multi-select custom-page-css border rounded overflow-hidden"
                options={carCompany.map((item: ISelectOption) => ({
                  value: item.value,
                  label: item.label,
                  disabled: selectedCarCompany.includes(-1) && item.value !== -1,
                }))}
                showSearch={false}
                onChange={(values: number[]) => {
                  const isSelectAll = values.includes(-1) && !selectedCarCompany.includes(-1);
                  if (isSelectAll) {
                    form.setFieldsValue({ carCompany: [-1] });
                    setSelectedCarCompany([-1]);
                  } else {
                    const filtered = values.filter((v) => v !== -1);
                    form.setFieldsValue({ carCompany: filtered });
                    setSelectedCarCompany(filtered);
                  }
                }}
              />
            </Form.Item>

            <Form.Item
              layout='vertical'
              label="Mô tả quyền lợi"
              name="description"
              rules={[{ required: true, message: 'Vui lòng mô tả quyền lợi!' }]}
            >
              <TextArea
                rows={2}
                placeholder="Thành viên có quyền lợi này sẽ được những gì?" />
            </Form.Item>
          </div>
        </div>
      </Drawer>
    </Form>

  )
}
export default DrawerAddBenefitPolicies
